// eslint-disable-next-line
export const toggleMoment = (state, moment) => state.toggledMoment = moment;

// eslint-disable-next-line
export const lightboxImage = (state, url) => state.lightboxImage = url;



// WEBPACK FOOTER //
// ./src/store/mutations.js